import React, { useEffect, useState } from 'react';
import M from 'materialize-css/dist/js/materialize';
import { connect } from 'react-redux';
import { configs, convertToUppercase, translate, showMessageToastCustom, isNullOrEmpty, getPreAllocationArea, stringFormat, getNumberValueOrDefault, newObj, autoFocus } from '../../../utils/util';
import { withTranslation } from 'react-i18next';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import { ENUMS, VISIONS } from '../../../utils/constants';
import { onValueChange, validateInputsRequired } from "../../../utils/handleChangeHooks";
import { Select, Input, Button, BackButton, Title, Subtitle, SelectDock } from '../../../components/UI/ComponentsUI';
import ConfirmModal from '../../../components/UI/ConfirmModal';
import { getVision } from '../../../services/auth';
import ConfirmModalUI from '../../../components/UI/ConfirmModalUI';
import ModalReceiptQuantity from '../Receipt/MasterCim/ModalReceiptQuantity';
import { endProcessing, startProcessing } from '../../../actions/loadingAction';
import * as stockAction from '../../../actions/stockAction';

const ConfirmationItemModal = (props) => {
    let demmconfimed = false;
    let auxAlternative = 0;

    const goBack = props.location?.state?.goBack;
    const [config, setConfig] = useState({});
    const [confirmation, setConfirmation] = useState({});
    const [print, setPrint] = useState((getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) ? ENUMS.ePrintTypes.Click.value : props.printSelect);
    const [messageConfirmationBoxesQuantity, setMessageConfirmationBoxesQuantity] = useState('')
    const [openModalConfirmation, setOpenModalConfirmation] = useState(false)
    const originalMDR = props.confirmation.mdr
    const [confirmUngroup, setConfirmUngroup] = useState(false)

    useEffect(() => {
        if (getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) {
            props.setPrintSelect(ENUMS.ePrintTypes.Click.value);
        }
        setConfig(configs(ENUMS.eModules.PhysicalConfirmation.value, props.config?.items));

        var confirmationProps = props.confirmation;
        confirmationProps.printLabel = true;
        confirmationProps.place = "1";
        confirmationProps.preAllocationArea = props.filter?.truckKanban ? 'XD%' : getPreAllocationArea(getVision());
        confirmationProps.print = props.filter?.truckKanban ? ENUMS.ePrintTypes.Logistics.value : print;
        confirmationProps.mdrOrigin = confirmationProps.mdr;
        confirmationProps.changeMdr = true;
        confirmationProps.changeQme = true;
        confirmationProps.ungroup = false;
        confirmationProps.boxQuantity = calcBalance(confirmationProps)
        confirmationProps.boxQuantityItems = confirmationProps.boxQuantity === 1 ? confirmationProps.balance : confirmationProps.qme
        setConfirmation({ ...confirmationProps });
        autoFocus('boxQuantity')
        // eslint-disable-next-line
    }, []);

    const calcBalance = (value) => {
        if (value.balance) {
            var calc = parseInt(value.balance / (value.qme > 0 ? value.qme : 1) || 1);
            return calc > 0 ? calc : 1
        }

        return "";
    }

    const onChangeBoxQuantity = (event) => {
        if (getNumberValueOrDefault(event.target.value) > 0) {
            var piecePerBox = parseInt(getNumberValueOrDefault(props.confirmation.balance) / getNumberValueOrDefault(event.target.value))
            confirmation.boxQuantityItems = piecePerBox
        }

        onValueChange(event, confirmation, setConfirmation);
    };

    const handleFormKeyDown = (e) => {
        if (e.key === 'Enter') {
            submit();
        }
    }

    const onChange = (event) => {
        onValueChange(event, confirmation, setConfirmation);
    };

    const onChangeResource = () => {
        try {
            if (!isNullOrEmpty(props.user.resource)) {
                const resource = props.resources.find((i) => i.resourceId === parseInt(props.user.resource));
                return print === ENUMS.ePrintTypes.Click.value && !isNullOrEmpty(resource.clickResourceName) ? resource.clickResourceName : resource.name;
            }
            return "";
        } catch (error) {
            console.log(error);
            return "";
        }
    }

    const isValid = () => {
        let result = true;
        if (!props.user.vision || props.user.vision === '') {
            showMessageToastCustom(translate('warning', 'general'), translate('select-vision', 'validations'), 3000, 'mdi mdi-alert-circle-outline red-text');
            result = false;
        }

        if ((!props.user.shed || props.user.shed === '') && Boolean(config.shedRequiredPhysicalConfirmation)) {
            showMessageToastCustom(translate('warning', 'general'), translate('select-shed', 'validations'), 3000, 'mdi mdi-alert-circle-outline red-text');
            result = false;
        }

        if ((!props.user.dock || props.user.dock === '') && Boolean(config.dockRequiredPhysicalConfirmation)) {
            showMessageToastCustom(translate('warning', 'general'), translate('select-dock', 'validations'), 3000, 'mdi mdi-alert-circle-outline red-text');
            result = false;
        }

        if (!props.user.resource || props.user.resource === '') {
            showMessageToastCustom(translate('warning', 'general'), translate('select-resource', 'validations'), 3000, 'mdi mdi-alert-circle-outline red-text');
            result = false;
        }

        if (config.mdrRequired && (confirmation.mdr === '' || !confirmation.mdr)) {
            showMessageToastCustom(translate('warning', 'general'), translate('mdr-not-informed', 'physical-confirmation'), 3000, 'mdi mdi-alert-circle-outline red-text');
            result = false;
        }
        if (confirmation.balance < (parseInt(confirmation.boxQuantity || 0) * parseInt(confirmation.boxQuantityItems || 0))) {
            if (!demmconfimed) {
                const modal = M.Modal.init(document.getElementById('deemconfirmed'));
                modal.open();
                result = false;
            }
            demmconfimed = false;
        }

        if (print === ENUMS.ePrintTypes.Click.value && ((onChangeResource() ?? "") === "")) {
            showMessageToastCustom(translate('warning', 'general'), translate('missing-click-resource-name', 'validations'), 3000, 'mdi mdi-alert-circle-outline red-text');
            result = false;
        }

        if (confirmation.ungroup && !confirmUngroup) {
            const modal = M.Modal.init(document.getElementById('ModalUngroup'));
            modal.open();
            return false
        }

        return result;
    }

    useEffect(() => {
        if (confirmUngroup) {
            preSubmit()
            setConfirmUngroup(false)
        }

        // eslint-disable-next-line
    }, [confirmUngroup]);

    const preSubmit = () => {
        if (isValid() && validateInputsRequired("formConfirmationItemModal")) {
            if (confirmation.boxQuantity > 1 && Number(confirmation.boxQuantityItems) === 1) {
                setMessageConfirmationBoxesQuantity(stringFormat(translate('receiptMultipleBoxes1PrintConfirmation', 'physical-confirmation'), confirmation.boxQuantity))
                setOpenModalConfirmation(true)
            }
            else if (confirmation.boxQuantity >= 50) {
                setMessageConfirmationBoxesQuantity(stringFormat(translate('generating50OrMorePrintsConfirmation', 'physical-confirmation'), confirmation.boxQuantity))
                setOpenModalConfirmation(true)
            }
            else {
                //if (isValidMdr() && isValidQme()) {
                if (isValidMdr()) {
                    submit();
                }
            }
        }
    }

    const submit = () => {
        if (isValid() && validateInputsRequired("formConfirmationItemModal")) {
            var shedRequired = Boolean(config.shedRequiredPhysicalConfirmation);
            var dockRequired = Boolean(config.dockRequiredPhysicalConfirmation);
            confirmation.dock = confirmation.place === "1" && (!dockRequired || props.filter?.truckKanban) ? "M01" : props.user.dock;
            confirmation.shed = !shedRequired || props.filter?.truckKanban ? "" : props.sheds.find((i) => i.id === props.user.shed)?.code;
            confirmation.preAllocation = props.filter?.truckKanban || confirmation.place === "1" ? "S" : "N"
            confirmation.preAllocationArea = props.filter?.truckKanban ? 'XD%' : (confirmation.place === "2" ? confirmation.dock : confirmation.preAllocationArea)
            confirmation.resource = onChangeResource();
            confirmation.truckKanban = props.filter?.truckKanban
            confirmation.print = props.filter?.truckKanban ? 'L' : print;

            if (confirmation.ungroup) {
                submitUngroup(confirmation, 1);
            } else {
                confirmation.alternativeMDRAreas = config.alternativeMDRAreas
                props.insertInstantConfirmationReceipt(confirmation, props.user, (data) => {
                    sendAlternativeChangeLocation(data);
                });
            }
        }
    }

    const validateDeemSqpLeave = () => {
        if (!confirmation.truckKanban && Boolean(config.enableModalConfirmSqp) && originalMDR !== confirmation.mdr) {
            const modal = M.Modal.init(document.getElementById('ModalSQP'));
            modal.open();
        } else if (!confirmation.truckKanban && Boolean(config.enableModalConfirmDeem) && validadeRemainingBalance() !== 0) {
            const modal = M.Modal.init(document.getElementById('ModalDEEM'));
            modal.open();
        } else {
            leave();
        }
    }

    const sendAlternativeChangeLocation = (data) => {
        if (!confirmation.truckKanban && data) {
            props.startProcessing("Enviando Mdr Alternativo Locação...")
            data.forEach(element => {
                const dataSend = {
                    print: print,
                    resource: onChangeResource(),
                    printer: props.user?.printer,
                    idLabel: element.id,
                    dataToPrinter: element.dataToPrint
                };
                props.alternativeChangeLocation(dataSend, () => {
                    auxAlternative = auxAlternative + 1;
                    if (auxAlternative === data.length) {
                        props.hideLoading();
                        validateDeemSqpLeave();
                    }
                })
            });
        } else {
            validateDeemSqpLeave();
        }
    }

    const submitUngroup = (confirmation, aux) => {
        var dataPrint = newObj(confirmation);
        dataPrint.boxQuantity = 1;
        props.insertInstantConfirmationReceipt(dataPrint, props.user, () => {
            if (aux === confirmation.boxQuantity) {
                props.hideLoading();
                validateDeemSqpLeave();
            } else {
                submitUngroup(confirmation, aux + 1)
            }
        });
    }

    const updateDate = (item, value) => {
        props.updateDate(
            item.partNumberCode,
            value,
            item.perishable === 'P' ? 'production_date' : 'expiration_date'
        );
    }

    const onConfirmModal = () => {
        demmconfimed = true;
        submit();
    }

    const leave = () => {
        if (goBack) {
            props.history.goBack();
        } else {
            props.setActiveTab(0);
            props.history.push({ pathname: '../V2/receiptStorages', ...props });
        }
    }

    const validadeRemainingBalance = () => {
        var remainingQuantity = props.confirmation.balance;
        var qtd = confirmation.boxQuantity * confirmation.boxQuantityItems;
        if (qtd > 0) {
            remainingQuantity = remainingQuantity - qtd;
        }
        return remainingQuantity;
    }

    const onCancel = () => {
        const modelAux = confirmation;
        modelAux.mdrOrigin = modelAux.mdr;
        modelAux.changeMdr = false;
        setConfirmation(modelAux)
        submit();
    }

    const onCancelQme = () => {
        const modelAux = confirmation;
        modelAux.changeQme = false;
        setConfirmation(modelAux)
        submit();
    }


    const isValidMdr = () => {
        if (!isNullOrEmpty(confirmation.mdrOrigin) && confirmation.mdrOrigin !== confirmation.mdr) {
            const modal = M.Modal.init(document.getElementById('confirmMdrStorage'));
            if (Boolean(config.controlDeparaUSer)) {
                if (config.usersDepara && config.usersDepara.includes(props.user.userName)) {
                    modal.open();
                } else {
                    showMessageToastCustom(translate('warning', 'general'), "Usuário não cadastrado no De-Para", 3000, 'mdi mdi-alert-circle-outline red-text');
                    onCancel()
                }
            } else {
                modal.open();
            }
        }
        else {
            return true;
        }
    }

    const isValidQme = () => {
        if (!isNullOrEmpty(confirmation.boxQuantityItems) && confirmation.boxQuantityItems !== confirmation.qme) {
            const modal = M.Modal.init(document.getElementById('confirmQmeStorage'));
            if (Boolean(config.controlDeparaUSer)) {
                if (config.usersDepara.includes(props.user.userName.replace("fiatauto\\", ""))) {
                    modal.open();
                } else {
                    onCancelQme()
                }
            } else {
                modal.open();
            }
        }
        else {
            return true;
        }
    }

    const isMasterCim = () => {
        if (props.receiptsGroup && props.receiptsGroup.length > 0) {
            return props.receiptsGroup.find((f) => f.id === confirmation.id);
        }
    }

    const onCheckItem = (confirmation) => {
        confirmation.ungroup = confirmation.ungroup ? false : true;
        setConfirmation({ ...confirmation });
    }

    const goToSQPForm = () => {
        props.selectSqp({ journey: props.confirmation.journey, mvmNumber: props.confirmation.mvmNumber, fromReceipt: true, partNumberCode: props.confirmation.partNumberCode })
        props.history.push({ pathname: '/warehousemanagement/deemsqp/sqpform' })
    }

    const goToDEEMForm = () => {
        props.selectDeem({ journey: props.confirmation.journey, mvmNumber: props.confirmation.mvmNumber, fromReceipt: true, partNumberCode: props.confirmation.partNumberCode })
        props.history.push({ pathname: './../../warehousemanagement/deemsqp/deemform' })
    }

    return (
        <div>
            <BackButton {...props} onClick={() => leave()} />
            <div className="container-fluid h-65">
                <div className="row">
                    <Title icon="mdi mdi-clipboard-check" label={translate("physical-confirmation:phisicalconfirmation")} />
                    <Subtitle icon="mdi mdi-layers" label={confirmation.partNumberCode} />
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container" style={{ width: '96%' }}>
                    <div className="card">
                        <div className="card-content" style={{ padding: '3px', paddingBlockEnd: '1px' }}>
                            <div>
                                <div className="col s12">
                                    <span className="field sixth-text-color f-1p5r" style={{ marginBottom: 0 }}>{confirmation.partNumberCode}</span>
                                    <span className="field sixth-text-color f-1p5r" style={{ marginBottom: 0, marginLeft: 50 }}>{translate('physical-confirmation:almox')}: {confirmation.almox}</span>
                                </div>
                                <div className="col s12">
                                    <span className="field f-1r sixth-text-color" style={{ marginBottom: 0 }}>{confirmation.partNumberDescription}</span>
                                </div>
                                <div className="row">
                                    <div className="input-field no-padding col s3">
                                        <span className="field f-1r" style={{ marginBottom: 0 }}>{props.confirmation.balance}</span>
                                        <label className="active" htmlFor="lot"> {translate('general:available')}</label>
                                    </div>
                                    <div className="input-field no-padding col s3">
                                        <span className="field f-1r" style={{ marginBottom: 0 }}>{props.confirmation.qme || ''}</span>
                                        <label className="active" htmlFor="qme">{translate('physical-confirmation:qme')}</label>
                                    </div>
                                    <div className="input-field no-padding col s4">
                                        <span className="field f-1r" style={{ marginBottom: 0 }}>{props.confirmation.mdr || ''}</span>
                                        <label className="active" htmlFor="qme">{translate('physical-confirmation:mdr-origin')}</label>
                                    </div>
                                </div>
                                <form onKeyDown={handleFormKeyDown} id="formConfirmationItemModal">
                                    <div className="row">
                                        <div className="input-field no-padding col s6">
                                            <Input
                                                id="boxQuantity"
                                                name="boxQuantity"
                                                className="required"
                                                required
                                                aria-required="true"
                                                type="number"
                                                value={confirmation.boxQuantity}
                                                onChange={onChangeBoxQuantity}
                                                onBlur={onChangeBoxQuantity}
                                                min={1}
                                                maxLength="6"
                                                step="1"
                                                label={translate('volume', 'physical-confirmation')}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                id="mdr"
                                                name="mdr"
                                                type="text"
                                                required
                                                value={confirmation.mdr || ''}
                                                onChange={(e) => {
                                                    convertToUppercase(e);
                                                    onChange(e)
                                                }}
                                                maxLength="5"
                                                label={translate('physical-confirmation:mdr')}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s12">
                                            <Input
                                                id="boxQuantityItems"
                                                name="boxQuantityItems"
                                                className="required"
                                                required
                                                aria-required="true"
                                                type="number"
                                                value={confirmation.boxQuantityItems}
                                                onChange={onChange}
                                                onBlur={onChange}
                                                min={1}
                                                maxLength="10"
                                                label={translate('partnumber', 'physical-confirmation')}
                                            />
                                        </div>
                                        {
                                            !props.filter?.truckKanban &&
                                            <>
                                                <div className="input-field no-padding col s6">
                                                    <Select
                                                        id="place"
                                                        name="place"
                                                        label={translate('area', 'physical-confirmation')}
                                                        notOption
                                                        display="description"
                                                        defaultValue={confirmation.place || '1'}
                                                        change={onChange}
                                                        data={[
                                                            { id: "1", text: translate('storage', 'physical-confirmation') },
                                                            { id: "2", text: translate('entrance-area', 'physical-confirmation') },
                                                        ]}
                                                    />
                                                </div>
                                                {
                                                    confirmation.place === "1" &&
                                                    <div className="input-field col s5" style={{ paddingTop: '21px', paddingLeft: '0px', paddingRight: '0px', paddingBottom: '0px' }}>
                                                        <div className="input-field" style={{ marginTop: '13px' }}>
                                                            <Input
                                                                id="preAllocationArea"
                                                                name="preAllocationArea"
                                                                className="required"
                                                                required
                                                                type="text"
                                                                defaultValue={confirmation.preAllocationArea}
                                                                onChange={onChange}
                                                                label={translate('pre-allocation-area', 'physical-confirmation')}
                                                                onKeyUp={convertToUppercase}
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    confirmation.place === "2" &&
                                                    <div className="input-field no-padding col s5">
                                                        <div className="input-field" style={{ marginTop: '13px' }}>
                                                            <SelectDock
                                                                unload
                                                                required={confirmation.place === 2}
                                                                id="preAllocationArea"
                                                                name="preAllocationArea"
                                                                filterArea
                                                                shedId={props.user.shed}
                                                                value={props.user.dock}
                                                                onChange={onChange}
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    getVision() !== VISIONS.Jeep && confirmation.place === "2" &&
                                                    <div className="input-field col s5" style={{ paddingTop: '21px', paddingLeft: '0px', paddingRight: '0px', paddingBottom: '0px' }}>
                                                        <div className="input-field" style={{ marginTop: '13px' }}>
                                                            <Input
                                                                required={confirmation.place === 2}
                                                                id="preAllocationArea"
                                                                name="preAllocationArea"
                                                                defaultValue={props.user.dock}
                                                                disabled
                                                                onKeyUp={convertToUppercase}
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                                <div className="col s12 no-padding" >
                                                    <div className="input-field">
                                                        <Select
                                                            required
                                                            id="print"
                                                            name="print"
                                                            display="name"
                                                            notOption
                                                            label={translate('print-type', 'physical-confirmation')}
                                                            placeHolder={translate('choose-one-option', 'general')}
                                                            data={[
                                                                { id: ENUMS.ePrintTypes.Logistics.value, text: translate(ENUMS.ePrintTypes.Logistics.text, 'physical-confirmation') },
                                                                { id: ENUMS.ePrintTypes.Click.value, text: translate(ENUMS.ePrintTypes.Click.text, 'physical-confirmation') },
                                                                { id: ENUMS.ePrintTypes.NotPrint.value, text: translate(ENUMS.ePrintTypes.NotPrint.text, 'physical-confirmation') },
                                                            ]}
                                                            change={(e) => {
                                                                props.setPrintSelect(e.target.value);
                                                                setPrint(e.target.value);
                                                                onChange(e);
                                                            }}
                                                            defaultValue={print}
                                                        />
                                                    </div>

                                                </div>
                                            </>
                                        }
                                        <>
                                            {confirmation.perishable === 'P' || confirmation.perishable === 'V' ?
                                                <div className="sixth-text-color" style={{ marginTop: '20px' }}>
                                                    <Input
                                                        type="date"
                                                        label={confirmation.perishable === 'P' ? translate('production-date', 'physical-confirmation') : translate('expiration-date', 'physical-confirmation')}
                                                        id={confirmation.perishable === 'P' ? 'productionDate' : 'expirationDate'}
                                                        name={confirmation.perishable === 'P' ? 'productionDate' : 'expirationDate'}
                                                        onChange={(e) => {
                                                            updateDate(confirmation, e.target.value);
                                                            onChange(e);
                                                        }}
                                                        required
                                                        className="sixth-text-color"
                                                    />
                                                </div>
                                                : null}
                                        </>
                                    </div>
                                    <div className="row">
                                        <div className="col s8" style={{ padding: '0px', color: 'red', paddingTop: '5px', paddingBottom: '5px' }}>
                                            <label style={{ color: 'red', fontSize: '1.3rem' }} htmlFor="remainingQuantity">{translate('physical-confirmation:remainingQuantity')}: {validadeRemainingBalance()}</label>
                                        </div>
                                        <div className="col s3" style={{ padding: '0px', paddingBottom: '30px' }}>
                                            <span
                                                className="title sixth-text-color right"
                                                style={{ position: 'absolute', right: '5px', zIndex: '999', cursor: 'pointer' }}
                                            >
                                                <ModalReceiptQuantity
                                                    truckKanban={props.filter?.truckKanban}
                                                    id="ConfirmationItemModalPallet"
                                                    receipt={newObj(props.confirmation)}
                                                    callback={() => {
                                                        props.setActiveTab(1);
                                                        props.history.goBack();
                                                    }} />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        {props.filter?.truckKanban &&
                                            <div className="col s6">
                                                <Input
                                                    type="checkbox"
                                                    onChange={() => onCheckItem(confirmation)}
                                                    id="select"
                                                    name="select"
                                                    label="Desagrupar"
                                                    checked={confirmation.ungroup}
                                                />
                                            </div>
                                        }

                                    </div>
                                </form>
                            </div>
                            <div className="row">
                                <Button onClick={leave} text={translate('cancel', 'general')} secundary="true" />
                                <Button disabled={isMasterCim()} onClick={preSubmit} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ConfirmModal
                id="deemconfirmed"
                data={{ title: translate("physical-confirmation:atention-deem"), message: translate('physical-confirmation:deem-generating') }}
                onConfirm={onConfirmModal}
                btnCancel={translate('general:cancel')}
                btnConfirm={translate('general:confirm')} />

            <ConfirmModal
                id="confirmMdrStorage"
                data={{ title: translate('warning', 'general'), message: translate('changeMDR', 'physical-confirmation').replace('{confirmation.mdrType}', confirmation.mdrOrigin).replace('{model.mdrType}', confirmation.mdr) }}
                onConfirm={submit}
                onCancel={onCancel}
                btnCancel={translate('only-this-time', 'physical-confirmation')}
                btnConfirm={translate('confirm', 'general')} />

            <ConfirmModal
                id="confirmQmeStorage"
                data={{ title: translate('warning', 'general'), message: translate('changeQme', 'physical-confirmation').replace('{confirmation.qmeOrigin}', confirmation.qme).replace('{model.qme}', confirmation.boxQuantityItems) }}
                onConfirm={submit}
                onCancel={onCancelQme}
                btnCancel={translate('only-this-time', 'physical-confirmation')}
                btnConfirm={translate('confirm', 'general')} />

            <ConfirmModalUI
                open={openModalConfirmation}
                id="messageAlert"
                data={{
                    title: `${translate('validations:attention')} ${translate('confirm', 'general')}`,
                    message:
                        <span className="title col s12" style={{ color: 'red' }}>
                            {messageConfirmationBoxesQuantity}
                        </span>
                }}
                onConfirm={() => {
                    setOpenModalConfirmation(false);
                    //if (isValidMdr() && isValidQme()) {
                    if (isValidMdr()) {
                        submit();
                    }
                }}
                onCancel={() => setOpenModalConfirmation(false)}
                onClose={() => setOpenModalConfirmation(false)}
                showCancel={true}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')} />
            <ConfirmModal
                id="ModalSQP"
                data={{ title: translate('RegisterSQP', 'physical-confirmation'), message: translate('SQPGenerationMessage', 'physical-confirmation') }}
                onConfirm={() => goToSQPForm()}
                onCancel={() => leave()}
                btnCancel={translate('general:cancel')}
                btnConfirm={translate('general:confirm')} />
            <ConfirmModal
                id="ModalDEEM"
                data={{ title: translate('RegisterDEEM', 'physical-confirmation'), message: translate('DEEMGenerationMessage', 'physical-confirmation') }}
                onConfirm={() => goToDEEMForm()}
                onCancel={() => leave()}
                btnCancel={translate('general:cancel')}
                btnConfirm={translate('general:confirm')} />
            <ConfirmModal
                id="ModalUngroup"
                data={{ title: translate('validations:attention'), message: translate('confirmUngroup', 'physical-confirmation') }}
                onConfirm={() => setConfirmUngroup(true)}
                btnCancel={translate('general:cancel')}
                btnConfirm={translate('general:confirm')} />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        confirmation: state.physicalConfirmationReducer.confirmation,
        user: state.userReducer.user,
        config: state.configReducer.config,
        sheds: state.configReducer.sheds,
        receipt: state.physicalConfirmationReducer.receipt,
        areas: state.areaReducer.areas,
        resources: state.logisticsResourceReducer.list,
        printSelect: state.physicalConfirmationReducer.printSelect,
        filter: state.physicalConfirmationReducer.filter,
        receiptsGroup: state.physicalConfirmationReducer.receiptsGroup
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        hideLoading: () => {
            dispatch(endProcessing());
        },
        startProcessing: (message) => {
            dispatch(startProcessing(message));
        },
        updateDate: (partnumber, value, key) => {
            dispatch(PhysicalConfirmationService.updateDate(partnumber, value, key));
        },
        insertInstantConfirmationReceipt: (item, userConfig, callback) => {
            dispatch(PhysicalConfirmationService.insertInstantConfirmation(item, userConfig, callback));
        },
        alternativeChangeLocation: (item, callback) => {
            dispatch(PhysicalConfirmationService.alternativeChangeLocation(item, callback));
        },
        setActiveTab: (tabIndex) => {
            dispatch(PhysicalConfirmationService.setActiveTab(tabIndex));
        },
        setPrintSelect: (printSelect) => {
            dispatch(PhysicalConfirmationService.setPrintSelect(printSelect));
        },
        selectSqp: (selectSqp) => {
            dispatch(stockAction.setSqp(selectSqp));
        },
        selectDeem: (selectDeem) => {
            dispatch(stockAction.setDeem(selectDeem));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ConfirmationItemModal));